<section class="object">
  <div class="header">
    <h2>Element Details</h2>
  </div>
  <div class="content">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Page Details
          </mat-panel-title>
          <mat-panel-description>
            select page or create new page
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div>
          <!-- search webpages field -->
          <div>
            <form class="example-form">
              <input *ngIf="hideSearchBox" type="text" #box (keyup)="getValue(box.value)"
                placeholder="select an existing page or create a new one" [matAutocomplete]="auto" name="webpageSearch"
                [ngModel]="newElement.changedwebpageId" (ngModelChange)="searchWebPage($event)">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="displayobject(page)" *ngFor="let page of filterdWebPages" [value]="page.name">
                  {{page.name}}
                </mat-option>
                <a (click)="createPagebtn()" *ngIf="showCreateOption">
                  <mat-option>create new page with {{displayValue}}</mat-option>
                </a>
              </mat-autocomplete>
            </form>
          </div>
          <!-- create new page -->
          <div class="new" *ngIf="showModal=='createpageoption'">
            <span class="form__field">
              <input id="page__name" type="text" [(ngModel)]="newElement.wpname" name="PageName"
                matTooltipPosition="right" matTooltip="Page Name" class="form__input" placeholder="Page Name*">
            </span>
            <span class="form__field">
              <input id="page__url" type="text" [(ngModel)]="newElement.wpurl" name="URL" matTooltipPosition="right"
                matTooltip="URL" class="form__input" placeholder="URL">
            </span>
            <span class="form__field">
              <input id="page__description" type="text" [(ngModel)]="newElement.wpdesc" name="Description"
                matTooltipPosition="right" matTooltip="Description" class="form__input" placeholder="Description">
            </span>
            <!-- check box -->
            <mat-checkbox class="example-margin" [(ngModel)]="newElement.wpdefaultPage">Default to all
              objects</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
      <!-- ------------------ object details ----------------------->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Element Details
          </mat-panel-title>
          <mat-panel-description>
            locaters of element
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!-- object details -->
        <div>
          <div class="details">
            <!-- page name -->
            <span class="form__field1" *ngIf="showModal=='displaywebobject'">
              <input type="text" matTooltipPosition="right" matTooltip="Current Page" class="form__input"
                name="webpage_name" [ngModel]="getcurrnetPageName(
                            newElement.selectedWebPageId?
                              newElement.selectedWebPageId:
                              newElement.webpageId.$oid
                              )?.name" disabled required>
            </span>
            <!-- logical name -->
            <span class="form__field1">
              <input id="element__name" type="text" name="logical_name" [(ngModel)]="newElement.name"
                matTooltipPosition="right" matTooltip="Name" required class="form__input" placeholder="Logical Name *"
                required>
            </span>
            <!-- object type -->
            <mat-form-field class="elementType">
              <mat-select [(ngModel)]="newElement.webobjectType" id="element_type" name="element_type" selected="XPath">
                <mat-option *ngFor="let wot of webobjecttype" [value]="wot.name" title="{{wot.desc}}">{{wot.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="elementType" *ngIf="showModal=='selectWebPageOption'">
              <mat-label class="label">Select Web Page *</mat-label>
              <mat-select [ngModel]="getcurrnetPageName(
                newElement.selectedWebPageId?
                  newElement.selectedWebPageId:
                  newElement.webpageId.$oid
                  )?.name" [(ngModel)]="selectedWebPage" id="element_type" name="element_type" selected="XPath"
                (selectionChange)="onSelectionChange()">
                <mat-option *ngFor="let wp of webpages" [value]="wp.name" title="{{wp.name}}">{{wp.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="form__field1" *ngIf="showModal=='selectWebPageOptions'">
              <input type="text" matTooltipPosition="right" matTooltip="Current Page" class="form__input"
                name="webpage_name" [ngModel]="getcurrnetPageName(
                  newElement.webpageId.$oid
                  )?.name" disabled required>
            </span>
            <span class="primary">
              <mat-panel-title>
                Set As Primary
              </mat-panel-title>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="dom_id" name="primaryLocator"
                  [checked]="newElement.primary_locator === 'dom_id'" (click)="toggleRadio('dom_id')">
              </div>
              <div class="optiondiv">
                <p>Dom ID</p>
              </div>
              <div>
                <input id="dom__id" type="text" name="dom_id" [(ngModel)]="newElement.dom_id" matTooltipPosition="right"
                  matTooltip="dom_id" class="form__input" placeholder="Dom Id">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="dom_name" name="primaryLocator"
                  [checked]="newElement.primary_locator  === 'dom_name'" (click)="toggleRadio('dom_name')">
              </div>
              <div class="optiondiv">
                <p>Dom Name</p>
              </div>
              <div>
                <input id="dom__name" type="text" name="DomName" [(ngModel)]="newElement.dom_name"
                  matTooltipPosition="right" matTooltip="Dom Name" class="form__input" placeholder="Dom Name">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="class" name="primaryLocator" [checked]="newElement.primary_locator === 'class'"
                  (click)="toggleRadio('class')">
              </div>
              <div class="optiondiv">
                <p>Class</p>
              </div>
              <div>
                <input id="element__class" type="text" name="class" [(ngModel)]="newElement.class"
                  matTooltipPosition="right" matTooltip="Class" class="form__input" placeholder="Class">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="tag" name="primaryLocator" [checked]="newElement.primary_locator === 'tag'"
                  (click)="toggleRadio('tag')">
              </div>
              <div class="optiondiv">
                <p>Tag</p>
              </div>
              <div>
                <input id="element__tag" type="text" name="tag" [(ngModel)]="newElement.tag" matTooltipPosition="right"
                  matTooltip="Tag" class="form__input" placeholder="Tag">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="css" name="primaryLocator" [checked]="newElement.primary_locator === 'css'"
                  (click)="toggleRadio('css')">
              </div>
              <div class="optiondiv">
                <p>Css</p>
              </div>
              <div>
                <input id="element__css" type="text" name="css" [(ngModel)]="newElement.css" matTooltipPosition="right"
                  matTooltip="CSS" class="form__input" placeholder="CSS">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="linkText" name="primaryLocator"
                  [checked]="newElement.primary_locator === 'link'" (click)="toggleRadio('link')">
              </div>
              <div class="optiondiv">
                <p>Link Text</p>
              </div>
              <div>
                <input id="element__LinkText" type="text" name="linkText" [(ngModel)]="newElement.link"
                  matTooltipPosition="right" matTooltip="Link Text" class="form__input" placeholder="Link Text">
              </div>
            </span>
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="partialLinkText" name="primaryLocator"
                  [checked]="newElement.primary_locator === 'partial_link'" (click)="toggleRadio('partial_link')">
              </div>
              <div class="optiondiv">
                <p>Partial Link Text</p>
              </div>
              <div>
                <input id="element__partialLinkText" type="text" name="PartialLinkText"
                  [(ngModel)]="newElement.partial_link" matTooltipPosition="right" matTooltip="Partial Link Text"
                  class="form__input" placeholder="Partial Link Text">
              </div>
            </span>

            
            <span class="form__field">
              <div class="optiondiv">
                <input type="radio" id="horizontal_index" name="primaryLocator"
                  [checked]="newElement.primary_locator === 'horizontal_index'" (click)="toggleRadio('horizontal_index')">
              </div>
              <div class="optiondiv">
                <p>Horizontal Index</p>
              </div>
              <div>
                <input id="horizontal_index" type="text" name="horizontal_index" [(ngModel)]="newElement.horizontal_index"
                  matTooltipPosition="right" matTooltip="horizontal_index" class="form__input" placeholder="Horizontal Index">
              </div>
            </span>
            <ng-container *ngFor="let xpath of newElement.xpaths; let i = index; trackBy: trackByFn">
              <span class="form__field">
                <div class="optiondiv">
                  <input type="radio" [id]="'xpath_' + i" name="primaryLocator"
                    [checked]="newElement.primary_locator === 'xpath_' + i" (click)="toggleRadio('xpath_' + i)">
                </div>
                <div class="optiondiv">
                  <p>XPath {{i+1}}</p>
                </div>
                <div>
                  <input id="element__xpath_{{i}}" type="text" name="Xpath" [(ngModel)]="newElement.xpaths[i]"
                    matTooltipPosition="right" matTooltip="XPath" class="form__input" placeholder="XPath {{i+1}}">
                </div>
              </span>
            </ng-container>
            <div style="margin-top: 10px;">
              <button mat-stroked-button type="button" (click)="addXPath()">Add XPath</button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="modal-footer">
      <div class="bottom">
        <div class="error">
          <mat-error *ngIf="!newElement?.webobjectType">Element type is required</mat-error>
          <mat-error *ngIf="!newElement?.name">Element name is required</mat-error>
        </div>
        <div class="btn">
          <button mat-button (click)="saveDialog()" cdkFocusInitial [disabled]="(!newElement?.name) && 
                  (!newElement?.webobjectType)"> Save</button>
          <button class="cancel" mat-button (click)="onCloseClick()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</section>